const doc = [({"se":({"js":({"components":({"app_layout":({"no_access":({"you_dont_have_no_access_to_this_page":"Du har inte åtkomst till denna sida."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;